import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useTextSetsGet = () => {
  const resource = `${API_BASE_URL}/api/v3/content/selector/created-by-me/?depth=2&shape=card&type=text_set`;
  return useRestQuery(resource);
};

export default useTextSetsGet;
